export default {
  name: 'pc-images',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '图片组',
          icon: 'el-icon-picture',
          content: {
            list: [{
              label: '默认',
              img: '',
              link: {}
            }],
            line: '1',
            height: 180
          },
          config: [{
            label: '图片组',
            name: 'list',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              link: {
                label: '链接',
                value: 'link'
              }
            }
          }, {
            label: '图片高度（px）',
            name: 'height',
            type: 'number'
          }, {
            label: '行数',
            name: 'line',
            type: 'radio-button',
            options: [{
              label: '一个',
              value: '1'
            }, {
              label: '二个',
              value: '2'
            }, {
              label: '三个',
              value: '3'
            }, {
              label: '四个',
              value: '4'
            }, {
              label: '五个',
              value: '5'
            }]
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};